import React from "react";

const CryptoWithdrawalIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="#F4E7E7"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.00012207" width="32" height="32" rx="16" fill="#F4E7E7" />
      <path
        d="M18.1779 12.8003H22.0889C22.2762 12.7985 22.4565 12.8713 22.5899 13.0027C22.7234 13.1341 22.799 13.3132 22.8 13.5005V23.3002C22.799 23.4874 22.7234 23.6666 22.5899 23.798C22.4565 23.9294 22.2762 24.0022 22.0889 24.0004H10.711C10.5238 24.0022 10.3435 23.9294 10.21 23.798C10.0766 23.6666 10.001 23.4874 10 23.3002V13.5005C10.001 13.3132 10.0766 13.1341 10.21 13.0027C10.3435 12.8713 10.5238 12.7985 10.711 12.8003H14.6221"
        stroke="#280101"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16.4 16.9602V8.00024"
        stroke="#280101"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4479 9.92024L16.3999 8.00024L14.3519 9.92024"
        stroke="#280101"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CryptoWithdrawalIcon;
